"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = HomeCategoryBanner;
const react_1 = __importDefault(require("react"));
const SharedDuplexBanner_1 = __importDefault(require("../SharedDuplexBanner/SharedDuplexBanner"));
const SharedImageBanner_1 = __importDefault(require("../SharedImageBanner/SharedImageBanner"));
function HomeCategoryBanner({ data, testId, }) {
    if (data.designType === "largeDuplex" || data.designType === "smallDuplex") {
        return react_1.default.createElement(SharedDuplexBanner_1.default, Object.assign({}, data, { testId: testId }));
    }
    if (data.designType === "smallImage" || data.designType === "largeImage") {
        return react_1.default.createElement(SharedImageBanner_1.default, Object.assign({}, data, { testId: testId }));
    }
    return null;
}
